import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import CalendarPlusIcon from '@icons/CalendarPlusIcon';
import { ButtonForIcon } from '@react/styledComponents';

const AddToCalendarButton = ({ event }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://addevent.com/libs/atc/1.6.1/atc.min.js';
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => {
            if (window.addeventatc) {
                window.addeventatc.settings({
                    license: 'aneqqoum2zlflrnc8mxw3054',
                    css: false,
                });
            }
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <ButtonForIcon className="addeventatc" type="button">
            <CalendarPlusIcon />
            <span className="start atc_node notranslate">{format(parseISO(event.beginsAt), 'dd/MM/yyyy k:mm')}</span>
            <span className="end atc_node notranslate">{format(parseISO(event.endsAt), 'dd/MM/yyyy k:mm')}</span>
            <span className="timezone atc_node notranslate">{event.timezone}</span>
            <span className="title atc_node notranslate">{event.title}</span>
            <span className="description atc_node notranslate">{event.description}</span>
            <span className="location atc_node notranslate">{event.displayLocation}</span>
            <span className="date_format atc_node notranslate">DD/MM/YYYY</span>
            <span className="all_day_event atc_node notranslate">false</span>
        </ButtonForIcon>
    );
};

AddToCalendarButton.propTypes = {
    event: PropTypes.shape({
        code: PropTypes.string,
        beginsAt: PropTypes.string,
        endsAt: PropTypes.string,
        timezone: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        displayLocation: PropTypes.string,
    }).isRequired,
};

export default AddToCalendarButton;
